/**
 * Which game a model call belongs to.
 *
 * The service keeps the cost ledger, so it needs to know whose call it is answering — that
 * is the whole of "cost per player" and "cost per session". Only the two identifiers the
 * game already has travel: the random per-browser id and the transcript id. No name, no
 * address, and never the API key's business.
 *
 * A single module value rather than a parameter threaded through five call sites, because a
 * browser plays one game at a time and every caller wants the same answer.
 *
 * `x-atc-session` is deliberately not reused: the radio already owns that header for its own
 * session token.
 */

let current: { sessionId?: string; anonymousId?: string } = {};

export function setAttribution(next: { sessionId?: string; anonymousId?: string }): void {
  current = next;
}

export function clearAttribution(): void {
  current = {};
}

export function attribution(): Record<string, string> {
  return {
    ...(current.sessionId ? { 'x-atc-game': current.sessionId } : {}),
    ...(current.anonymousId ? { 'x-atc-anon': current.anonymousId } : {}),
  };
}
